import { Box, Container, Divider, Typography } from "@mui/material"

const Contacts = () => {
  return (
    <Container>
      <Typography align="center" variant="h3">
        Contact <span style={{ color: "red" }}>Us</span>
      </Typography>
      <Divider sx={{ marginY: 2 }} />
      <Typography variant="h6" align="center" fontWeight={300} gutterBottom>
        Complete the form to get in contact with our team. Please allow up to
        two business days for a response to these inquiries.
      </Typography>

      <Box
        sx={{
          width: "100%",
          height: 500,
          background: "papayawhip",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" align="center" marginTop={7}>
          Coming soon!
        </Typography>
      </Box>

      {/* </Box> */}
    </Container>
  )
}
export default Contacts
